// Helpers for the command palette (Cmd+K workspace search, SPO-1533).

export const MIN_QUERY_LENGTH = 2;

export const GROUPS = ["teams", "athletes", "sessions"];

// Cmd+K on macOS, Ctrl+K elsewhere.
export const isOpenShortcut = (event) =>
  Boolean(event.metaKey || event.ctrlKey) &&
  !event.altKey &&
  !event.shiftKey &&
  event.key?.toLowerCase() === "k";

export const isMac = (
  platform = typeof navigator === "undefined" ? "" : navigator.platform || ""
) => /mac|iphone|ipad|ipod/i.test(platform);

// "YYYY-MM-DD" as a local date (new Date("2026-10-20") would be UTC).
export const parseDay = (iso) => {
  if (!iso) return null;
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

// The API response as one flat list, in display order, each with its link.
export const flattenResults = (data, workspaceId) => {
  if (!data) return [];
  const base = `/v2/${workspaceId}`;
  const teams = (data.teams || []).map((team) => ({
    key: `team:${team.id}`,
    group: "teams",
    id: team.id,
    title: team.name,
    team,
    to: `${base}/team/${team.id}`,
  }));
  const athletes = (data.athletes || []).map((a) => ({
    key: `athlete:${a.id}:${a.team_id}`,
    group: "athletes",
    id: a.id,
    title: a.name,
    athlete: a,
    to: `${base}/team/${a.team_id}?player=${encodeURIComponent(a.id)}`,
  }));
  const sessions = (data.sessions || []).map((s) => ({
    key: `session:${s.id}`,
    group: "sessions",
    id: s.id,
    title: s.name,
    session: s,
    to: `${base}/team/${s.team_id}/session/${s.id}`,
  }));
  return [...teams, ...athletes, ...sessions];
};

// Split `text` around the first match of `query` (ignoring case), for
// highlighting: [{ text, match }].
export const highlightParts = (text, query) => {
  const value = text || "";
  const q = (query || "").trim();
  if (!q) return [{ text: value, match: false }];
  const index = value.toLowerCase().indexOf(q.toLowerCase());
  if (index < 0) return [{ text: value, match: false }];
  return [
    { text: value.slice(0, index), match: false },
    { text: value.slice(index, index + q.length), match: true },
    { text: value.slice(index + q.length), match: false },
  ].filter((part) => part.text);
};

// The next highlighted row when moving with the arrow keys (wraps around).
export const moveIndex = (current, delta, count) => {
  if (!count) return -1;
  if (current < 0) return delta > 0 ? 0 : count - 1;
  return (current + delta + count) % count;
};
